<template>
  
  <search-picker 
    ref="searchPicker"
    path="vets" 
    attributes="id,name,email"
    :authToken="authToken"
    :fluid="fluid"
    :renderTitle="renderTitle"
    :renderDescription="renderDescription"
    @onClear="$emit('onClear')" 
    @onPick="onPick" 
  />

</template>

<script>

  import SearchPicker from "./search-picker"
  import VetService from "@/services/vet-service"

  export default {

    name: "VetPicker",

    props: {
      authToken: { type: String },
      fluid: { type: Boolean, default: true },      
    },
    
    components: {
      SearchPicker,
    },  

    methods: {

      renderTitle(vet) {
        return vet.name
      },

      renderDescription(vet) {
        return vet.email ? `<div class="m-t-10"><i class="envelope blue icon"></i> ${vet.email}</div>` : ""
      },

      clear() {
        this.$refs.searchPicker.clear()
      },      

      onPick(vet) {
        this.$emit("onPick", vet)
      },

      setSelected(vet) {
        this.$refs.searchPicker.setSelected(vet)
      },
    },
  }

</script>